
export default Accordion

const cssClasses = {
    active: 'is-active',
    added: 'is-added',
    adding: 'is-adding',
    collapsed: 'is-collapsed',
    condensed: 'is-condensed',
    disabled: 'is-disabled',
    empty: 'is-empty',
    ended: 'is-ended',
    hidden: 'is-hidden',
    invalid: 'is-invalid',
    lazyload: 'lazyload',
    lazyloaded: 'lazyloaded',
    lazyloading: 'lazyloading',
    loading: 'is-loading',
    locked: 'is-locked',
    minimised: 'is-minimised',
    pagination: 'has-pagination',
    paused: 'is-paused',
    playing: 'is-playing',
    removed: 'is-removed',
    removing: 'is-removing',
    rendering: 'is-rendering',
    searching: 'is-searching',
    sticky: 'is-sticky',
    tabbable: 'is-tabbable',
    transitioning: 'is-transitioning',
    transparent: 'is-transparent',
    visible: 'is-visible',
    zoomed: 'is-zoomed'
}

function Accordion(currentSelector, config, modifier = '') {
    const selector = document.querySelector(currentSelector)
    const settings = {
        singleOpen: true,
        expandInitial: false,
        expandAll: false,
        selectors: {
            item: `[js-accordion="item${modifier}"]`,
            parentItem: 'js-accordion-item-parent',
            childItem: '[js-accordion-item="child"]',
            control: `[js-accordion="control${modifier}"]`,
            genericControl: '[js-accordion-control]',
            content: `[js-accordion="content${modifier}"]`
        },
        ...config
    }

    const nodeSelectors = {
        controls: selector.querySelectorAll(settings.selectors.control),
        items: selector.querySelectorAll(settings.selectors.item)
    }

    const onInit = () =>  {
        setDefaultState()
        setEventListeners()
    }
    const setEventListeners = () => {
        selector.addEventListener('click', (event)=> handleClickEvent(event));
        selector.addEventListener('keydown', (event)=> handleKeyboardEvent(event));
    }
    const setDefaultState = () => {
        if (settings.expandAll) {
            expandAllItems()
        }

        if (settings.expandInitial) {
            expandInitialItem()
        }
    }

    const handleClickEvent = (event) => {
        if (!isTargetControl(event.target) || isDisabled(event.target)) {
            return
        }
        event.preventDefault()
        toggleItem(event.target)
    }

    const handleKeyboardEvent = (event) => {
        if (!isTargetControl(event.target) || isDisabled(event.target)) {
            return
        }

        if (isKeyPressArrowUp(event) || isKeyPressArrowDown(event)) {
            handleArrowEvents(event)
            return
        }

        if (isKeyPressHome(event) || isKeyPressEnd(event)) {
            handleHomeEndEvents(event)
        }
    }

    const handleArrowEvents = (event) => {
        event.preventDefault()

        const index = nodeSelectors.controls.indexOf(event.target)
        const direction = isKeyPressArrowUp(event) ? -1 : 1
        const length = nodeSelectors.controls.length
        const newIndex = (index + length + direction) % length

        nodeSelectors.controls[newIndex].focus()
    }

    const handleHomeEndEvents = (event) => {
        event.preventDefault()

        if (isKeyPressHome(event)) {
            nodeSelectors.controls[0].focus()
            return
        }

        if (isKeyPressEnd(event)) {
            nodeSelectors.controls[nodeSelectors.controls.length - 1].focus()
        }
    }

    const expandItem = (element) => {
        if (!element) {
            return
        }

        element.classList.add(cssClasses.active)
        element.querySelector(settings.selectors.control).setAttribute('aria-expanded', true)
    }

    const collapseItem = (element) => {
        if (!element) {
            return
        }

        element.classList.remove(cssClasses.active)
        element.querySelector(settings.selectors.control).setAttribute('aria-expanded', false)

        if (!element.hasAttribute(settings.selectors.parentItem)) {
            return
        }

        [...element.querySelectorAll(settings.selectors.childItem)].forEach((childElement) => {
            childElement.classList.remove(cssClasses.active)
            if (childElement.querySelector(settings.selectors.genericControl)) {
                childElement.querySelector(settings.selectors.genericControl).setAttribute('aria-expanded', false)
            }
        })
    }

    // NEW
    const isItemExpanded = (element) => {
        return element.classList.contains(cssClasses.active)
    }

    const collapseUnselectedItems = (element) => {
        nodeSelectors.items.forEach((item) => {
            if (isItemExpanded(item) && item !== element) {
                collapseItem(item)
            }
        })
    }

    const expandAllItems = () => {
        nodeSelectors.items.forEach((element) => {
            expandItem(element)
        })
    }

    const expandInitialItem = () => {
        nodeSelectors.items.forEach((element, index) => {
            if (index === 0) {
                expandItem(element)
                return
            }

            collapseItem(element)
        })
    }

    const collapseAllItems = () => {
        nodeSelectors.items.forEach((item) => {
            collapseItem(item)
        })
    }

    const toggleItem = (control) => {
        const item = control.closest(settings.selectors.item)

        if (settings.singleOpen) {
            collapseUnselectedItems(item)
        }

        if (isItemExpanded(item)) {
            collapseItem(item)
            return
        }

        expandItem(item)
    }

    const isKeyPressArrowDown = (event) => {
        return event.keyCode === 40 || event.keyCode === 34
    }

    const isKeyPressArrowUp = (event) => {
        return event.keyCode === 38 || event.keyCode === 33
    }

    const isKeyPressEnd = (event) => {
        return event.keyCode === 35
    }

    const isKeyPressHome = (event) => {
        return event.keyCode === 36
    }

    const isTargetControl = (target) => {
        return (target.closest(settings.selectors.control))
    }

    const isDisabled = (target) => {
        return selector.classList.contains(cssClasses.disabled)
    }

    const disable = () => {
        expandAllItems()

        selector.classList.add(cssClasses.disabled)

        nodeSelectors.controls.forEach((element) => {
            element.setAttribute('tabindex', -1)
        })
    }

    const enable = () => {
        collapseAllItems()

        selector.classList.remove(cssClasses.disabled)

        nodeSelectors.controls.forEach((element) => {
            element.setAttribute('tabindex', 0)
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    //     collapseAllItems,
    //     expandAllItems,
    //     expandInitialItem,
    //     disable,
    //     enable,
    // })
    onInit()
}

function AccordionContent(currentTheme, currentElem) {
        const theme = currentTheme
        const elem = currentElem
        const selectors = {
            control: '[js-accordion^="control"]',
            dataElement: '[js-container-count="data"]'
        }
        const nodeSelectors = {
            controls: [...document.querySelectorAll(selectors.control)],
            dataElement: document.querySelector(selectors.dataElement)
        }

    const onInit = () => {
        if (!nodeSelectors.dataElement) return
        const containerCount = nodeSelectors.dataElement.dataset.containerCount || 0

        for (let index = 0; index < containerCount; index++) {
            const modifier = index > 0 ? `-${index}` : ''
            const selector = `[js-accordion="container${modifier}"]`

            Accordion(selector, { singleOpen: true }, modifier)
        }
    }
    onInit()
}
document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector('.page-accordion');
    if (wrapper) {
        AccordionContent();
    }
}
)
